import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=5c124da2&scoped=true&"
import script from "./CategoryDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=5c124da2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c124da2",
  null
  
)

export default component.exports